function email_submit(customer_number,collection_id){
  
  //alert(customer_number+'-'+collection_id);
  clear_modal();
   document.getElementById("modal_head").innerHTML="Would you like share your email with this business to receive news and offers from them directly?<br><br>";
     
     
       
       document.getElementById("modal_desc").innerHTML="";
  document.getElementById('yesbtn').setAttribute('onclick','email_confirm('+customer_number+','+collection_id+')')    
  document.getElementById("ynbtns").style.display="block"    
  toggleModal();
  
 
  
}


function email_confirm(customer_number,collection_id){
//alert(customer_number+'-'+collection_id);

 $.post("https://buylocalus.com/apps/blusapp/email_sub_buspage.php",{customer_number:customer_number,collection_id:collection_id},function(data){
//alert('|'+data+'|');
    
  
   
   
   if (data=='success' || data=='exists'){
     if (data=='exists'){
     document.getElementById("email_conf").innerHTML="You have already subscribed to this list.";
       document.getElementById("email_conf").style.display="block";
   }
     
    if (data=='success'){
      document.getElementById("email_conf").innerHTML="Success! Thank you for subscribing.";
       document.getElementById("email_conf").style.display="block";
   } 
     
     
     
   }else{
      document.getElementById("email_conf").innerHTML="There was an error with your submission. Please try again.";
     //document.getElementById("email_conf").innerHTML=data;  
     document.getElementById("email_conf").style.display="block";
     
   }
   
   //set_points_od();
   toggleModal();
   
 }); 
  
}